<template>
  <vs-col vs-w="12" class="mt-2">
    <vs-row vs-w="12">
      <label for="" class="vs-input--label">{{label}}</label>
    </vs-row>

    <vs-row vs-w="12" v-if="limit">
      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
        <vs-row vs-w="12" vs-align="center">
          <vs-input
            class="inputx w-24"
            type="number"
            v-model="minSpendDecimalAmount"
          />
          <span class="ml-2">{{ minSpendCurrency }}</span>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="7" vs-xs="12">
        <vs-button @click="handleRemoveClick" type="filled" color="danger" icon="remove"
          ></vs-button
        >
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" v-if="!limit" vs-align="center">
      <vs-col vs-lg="6" vs-sm="5" vs-xs="12">
        <span class="ml-2 mr-4">No Limit</span>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="7" vs-xs="12">
        <vs-button @click="handleAddClick" type="filled" color="success" icon="add"
          ></vs-button
        >
      </vs-col>
    </vs-row>
  </vs-col>
</template>

<script>
import * as _ from "lodash";

export default {
  props: {
    limit: {
      type: Object,
    },
    limitType: {
      type: Number
    },
    label: {
      type: String
    }
  },
  data() {
    return {
    };
  },
  computed: {
    minSpendDecimalAmount: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        return this.limit.minimumSpendAmount.value / 100;
      },
      set(value) {
        this.limit.minimumSpendAmount.value = value * 100;
      },
    },
    minSpendCurrency: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        return this.limit.minimumSpendAmount.currency;
      }
    },
  },
  methods: {
    handleRemoveClick() {
      setTimeout(() => {
        this.$emit("limit-removed", this.limitType);
      }, 10);

    },
    handleAddClick() {
      setTimeout(() => {
        this.$emit("limit-added", this.limitType);
      }, 10);
    }
  },
};
</script>
